export default "__VITE_ASSET__6161bc85__"